export default "__VITE_ASSET__DVQ8T9rE__"